import { useState, useEffect } from "react";
import "./Sidebar.css";
import WorkspacePicker from "../workspace-picker/WorkspacePicker";
import { useSelector } from "react-redux";
import { selectForms, selectSelectedMenu, selectSelectedMenuId, selectTags, selectUIStates, selectUser } from "../../redux/features/appData";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";
import { useNavigate } from "react-router-dom";
import { iconPath, TagExtended } from "effno-core";
import { ICONS } from "../shared/media";
import { TagCard } from "../shared/TagCard";
import { CircleHelp, ConciergeBell, House, LayoutTemplate, Tag } from "lucide-react";

export const Sidebar = () => {

    const { reloadAll } = useCoreDataLoader();
    const navigate = useNavigate();

    const storeUser = useSelector(selectUser);
    const selectedMenu = useSelector(selectSelectedMenu);
    const selectedMenuId = useSelector(selectSelectedMenuId);
    const uiStates = useSelector(selectUIStates);
    const tags = useSelector(selectTags);
   
    return (
        <>
            <div className="sidebar-header">
                <WorkspacePicker selectedId={storeUser?.currentWorkspaceId || ""} />
            </div>
            
            <div className="sidebar-menus">

                {/* Main */}
               
                <div 
                    className="sidebar-menu"
                    onClick={()=>{
                        navigate("/home")
                    }}
                >
                    <div className="sidebar-menu-icon">
                        <House size={16} />
                        {/* // <img src={iconPath(ICONS.HOME, storeUser)} /> */}
                    </div>
                    <div className="sidebar-menu-name">
                        Home
                    </div>
                    
                </div>

                 {/* Tags */}   
                <div 
                    className="sidebar-menu"
                    onClick={()=>{
                        navigate("/tags")
                    }}
                >
                    <div className="sidebar-menu-icon">
                        <Tag size={16} />
                        {/* <img src={iconPath(ICONS.TAGS, storeUser)} /> */}
                    </div>
                    <div className="sidebar-menu-name">
                        Tags
                    </div>
                </div>

                <div className="sidebar-menu-tags">
                    {tags && tags.map((tag: TagExtended) => {
                        return (
                            <TagCard 
                                key={"sidebar-menu-tag-" + tag.id}
                                tag={tag} 
                            />
                        )

                    })}
                </div>
                    
                

                {/* Templates */}
                <div 
                    className="sidebar-menu"
                    onClick={()=>{
                        navigate("/templates")
                    }}
                >
                    <div className="sidebar-menu-icon">
                        <LayoutTemplate size={16} />
                        {/* <img src={iconPath(ICONS.TEMPLATES, storeUser)} /> */}
                    </div>
                    <div className="sidebar-menu-name">
                        Templates
                    </div>
                </div>

                {/* Help & Support */}

                <div 
                    className="sidebar-menu"
                    style={{marginTop: "auto"}}
                    onClick={()=>{
                        navigate("/help")
                    }}
                >
                    <div className="sidebar-menu-icon">
                        <CircleHelp size={16}/>
                        {/* <img src={iconPath(ICONS.HELP, storeUser)} /> */}
                    </div>
                    <div className="sidebar-menu-name">
                        Help Center
                    </div>
                </div>

                <div 
                    className="sidebar-menu"
                    onClick={()=>{
                        navigate("/support")
                    }}
                >
                    <div className="sidebar-menu-icon">
                        <ConciergeBell size={16}/>
                        {/* <img src={iconPath(ICONS.SUPPORT, storeUser)} /> */}
                    </div>
                    <div className="sidebar-menu-name">
                        Support
                    </div>
                </div>

            </div>
        </>
    )
}